import { CloseOutlined } from '@ant-design/icons'
import cn from 'classnames'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import AccessLevelControl from '../AccessLevelControl/AccessLevelControl'
import ScorePercentage from '../ScorePercentage/ScorePercentage'
import {
  getAccessActionKey,
  getLessonAccessControl,
  supportsContentOnly,
} from '../../utils/access'
import { AccessColumn, IconComponent, LessonRowProps } from '../../utils/types'
import styles from '../../index.module.css'

const CloseIcon = CloseOutlined as unknown as IconComponent

const LessonRow = ({
  lesson,
  themeName,
  standalone,
  accessDisabled,
  pendingActionKey,
  onAccessChange,
  onUpdateProgress,
  onReset,
}: LessonRowProps) => {
  const getProgressClass = () => {
    const progress = lesson.progress ?? 0
    if (progress < 75) return styles.progressLow
    if (progress < 90) return styles.progressMedium
    return styles.progressHigh
  }

  const renderAccessControl = (column: AccessColumn) => {
    // у контрольной и пробника нет режима «только контент» — клетка пустая
    if (column === 'materials' && !supportsContentOnly(lesson.work_type)) {
      return <div className={styles.emptyActionCell} />
    }

    const value = getLessonAccessControl(lesson, column)
    const actionKey = getAccessActionKey('lesson', lesson.id, column)
    const tooltip =
      column === 'materials'
        ? 'Открыть / закрыть материалы урока без выполнения заданий'
        : lesson.work_type === 'control'
          ? 'Открыть / закрыть доступ к контрольной'
          : lesson.work_type === 'probe'
            ? 'Открыть / закрыть доступ к пробнику'
            : 'Открыть / закрыть выполнение заданий в уроке'

    return (
      <AccessLevelControl
        state={value.state}
        disabled={value.disabled || accessDisabled}
        loading={pendingActionKey === actionKey}
        tooltip={tooltip}
        ariaLabel={tooltip}
        onClick={() =>
          onAccessChange({
            entityType: 'lesson',
            entityId: lesson.id,
            entityName: lesson.lesson_name,
            column,
            state: value.state,
            workType: lesson.work_type,
          })
        }
      />
    )
  }

  return (
    <div className={cn(styles.row, styles.staticRow)}>
      <div
        className={cn(
          styles.cell,
          styles.lessonNameCell,
          standalone && styles.themeCell,
        )}
      >
        <span className={styles.rowTitle}>{lesson.lesson_name}</span>
        {/* подпись с темой не нужна, если работа и тема названы одинаково
            (так приходят пробники и контрольные) */}
        {!!themeName && themeName !== lesson.lesson_name && (
          <span className={styles.themeCaption}>Тема: {themeName}</span>
        )}
      </div>
      <div className={cn(styles.cell, styles.center)}>
        {lesson.start_date || '—'}
      </div>
      <div className={cn(styles.cell, styles.center)}>
        {lesson.end_date || '—'}
      </div>
      <div
        className={cn(
          styles.cell,
          styles.center,
          styles.progressCell,
          getProgressClass(),
        )}
      >
        <ScorePercentage lesson={lesson} onSave={onUpdateProgress} />
      </div>
      {renderAccessControl('materials')}
      {renderAccessControl('tasks')}
      <TooltipWrapper title="Сбросить прогресс урока" placement="top">
        <button
          type="button"
          className={styles.resetButton}
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
            onReset()
          }}
        >
          <CloseIcon />
        </button>
      </TooltipWrapper>
    </div>
  )
}

export default LessonRow
